import {
    CREATESERVICE,
    DELETESERVICE,
    LISTOFSERVICE,
    EDITSERVICE,
    VIEWSERVICE,
    COUNT_SERVICE_GST,
  } from "./ApiRoutes";
  import { authData } from "./services";
  
  export const createService = async (data: object) => {
    const response = await authData.post(CREATESERVICE, data);
    return response?.data;
  };
  export const updateService = async (data: object) => {
    const response = await authData.put(`${EDITSERVICE}`, data);
    return response?.data;
  };
  export const listOfService = async (data: object) => {
    const response = await authData.post(LISTOFSERVICE, data);
    return response?.data;
  };
  export const viewService = async (id: number) => {
    const response = await authData.post(`${VIEWSERVICE}${id}`);
    return response?.data;
  };

  export const deleteService = async (id: number) => {
    const response = await authData.delete(`${DELETESERVICE}${id}`);
    return response?.data;
};
export const calculateServiceGstApi = async (data: object) => {
  const response = await authData.post(COUNT_SERVICE_GST, data);
  return response?.data;
};